import { render, staticRenderFns } from "./colorPicker.vue?vue&type=template&id=4934447f&scoped=true"
import script from "./colorPicker.vue?vue&type=script&lang=js"
export * from "./colorPicker.vue?vue&type=script&lang=js"
import style0 from "./colorPicker.vue?vue&type=style&index=0&id=4934447f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4934447f",
  null
  
)

export default component.exports